'use strict';
import React from 'react';
import NavBar from './navBar';
import SideMenu from './sideMenu';
import reportAction from '../actions/reportAction';
import reportStore from '../stores/reportStore';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import menuAction from '../actions/menuAction';
import Loading from './loading';

class ReportCreate extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleEmailClick = this.handleEmailClick.bind(this);
        this.handleEmailRemove = this.handleEmailRemove.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleCtrCheck = this.handleCtrCheck.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.upLoadImg = this.upLoadImg.bind(this);
        this.state = {
            report: {
                mcst: "",
                condoName: "",
                facility: "",
                category: "",
                severity: 0,
                description: "",
                reportImage: [],
                clientEmail: [],
                contractorIds: [],
            },
            email: "",
            warningMsg: "",
            processing: reportStore.getState().processing,
            processingFilter: filterStore.getState().processing,
            condos: filterStore.getState().condos,
            iniLoadCondo: filterStore.getState().iniLoadCondo,
            facility: reportStore.getState().facility,
            contractors: reportStore.getState().contractors,
            isReportCreated: reportStore.getState().isReportCreated,
        };
    }
    componentWillMount() {

    }
    componentDidMount() {
        reportStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange)
        menuAction.pageNumber(-1);
        reportAction.isReportCreated(false);
        if (!this.state.iniLoadCondo && !this.state.processingFilter) {
            //getMCST first
            filterAction.processing(true);
            filterAction.getCondoList();
        }

    }
    componentWillUnmount() {
        reportStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isReportCreated != this.state.isReportCreated && this.state.isReportCreated) {
            window.setTimeout(() => {
                window.location.reload();
            }, 3000);
        }
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            facility: state.facility,
            contractors: state.contractors,
            isReportCreated: state.isReportCreated
        });
    }
    onFilterChange(state) {
        this.setState({
            processingFilter: state.processing,
            iniLoadCondo: state.iniLoadCondo,
            condos: state.condos,
        });
    }

    upLoadImg(e) {
        e.preventDefault();
        let len = e.target.files.length;
        if (len > 3) {
            return this.setState({ warningMsg: "Maximum upload 3 pictures only" });
        } else {
            this.setState({ warningMsg: "" });
        }
        for (let i = 0; i < len; i++) {
            let file = e.target.files[i];
            this._previewImage(file, i);
        }
        //let file = e.target.files[0];
        //this._previewImage(file, 0);
    }
    _previewImage(file, index) {

        //to be modified
        let fr = new FileReader();
        fr.onload = (e) => {
            let imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
            let img = new Image();

            img.onload = () => {
                this.resizeImage(img, index);
            }

            img.src = imgUrl;
        }
        fr.readAsArrayBuffer(file);
    }
    dataURItoBlob(dataURI) {
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = window.atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }
    resizeImage(image, index) {
        let oHeight = image.naturalHeight;
        let oWidth = image.naturalWidth;
        let newImage, newSize;
        let oSize = { oHeight: oHeight, oWidth: oWidth };
        newSize = { width: 500, height: 500 * oHeight / oWidth };

        newImage = this._imgResize(image, newSize, oSize);
        let s = this.state.report;
        if (s.reportImage == "") s.reportImage = [];
        s.reportImage[index] = this.dataURItoBlob(newImage);
        this.setState({ report: s });
    }
    _imgResize(img, newSize, oSize) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext("2d");
        canvas.width = newSize.width;
        canvas.height = newSize.height;
        ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
        return canvas.toDataURL('image/jpeg', 1);

    }
    getCondoName(mcst){
        let len = this.state.condos.length;
        let condoName;
        for(let i = 0 ; i < len ; i++){
            if(this.state.condos[i].mcst == mcst){
                condoName = this.state.condos[i].condoName;
               
                break;
            }
        }
        return condoName;
    }
    handleChange(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        let value = e.target.value;
        let s = this.state.report;
        if (index == 0) {
            //selected condo
            //render facility and render contractor

            if (value != "") {
                if (value != this.state.report.mcst) {
                    reportAction.processing(true);
                    reportAction.getFacility(value);
                    reportAction.getContractor(value);
                   
                    s.mcst = value;
                    s.condoName = this.getCondoName(value);
                    s.facility = "";
                    s.category = "";
                    s.severity = 0;
                    s.description = "";
                    s.reportImage = [];
                    s.clientEmail = [];
                    s.contractorIds = [];
                    this.setState({ report: s });
                }
            }
        } else if (index == 1) {
            //select facility
            if (s.facility != value) {
                s.facility = value;
                s.category = "";
                this.setState({ report: s });
            }
        } else if (index == 2) {
            //select category
            s.category = value;
            this.setState({ report: s });
        } else if (index == 3) {
            s.severity = parseInt(value);
            this.setState({ report: s });
        }
    }
    handleEdit(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        let value;
        let s = this.state.report;
        if (index == 2) {
            value = e.target.value;
            s.category = value;
            this.setState({ report: s });
        } else if (index == 4) {
            value = e.target.value;
            s.description = value;
            this.setState({ report: s });
        }

    }
    handleCtrCheck(e) {
        let checked = e.target.checked;
        let contractorId = e.target.value;

        let s = this.state.report;
        if (checked) {
            if (s.contractorIds != "") {
                s.contractorIds = s.contractorIds.concat(contractorId);
            } else {
                s.contractorIds = [contractorId];
            }
        } else {
            //remove from list
            let len = s.contractorIds.length;
            for (let i = 0; i < len; i++) {
                if (s.contractorIds[i] == contractorId) {
                    s.contractorIds.splice(i, 1);
                    break;
                }
            }
        }
        this.setState({
            report: s
        });
    }
    handleSubmit(e) {

        let s = this.state.report;
        if (s.facility == "" || s.category == "") {
            //check if category is empty or not
            return this.setState({ warningMsg: "Please select facility and category" });
        }
        
        if (s.description == "" && s.reportImage == "") {
            return this.setState({ warningMsg: "Please either type the description or upload the image" });
        }
        

        let fd = new FormData();
        fd.append("category", s.category);
        fd.append("facility", s.facility);
        fd.append("mcst", s.mcst);
        fd.append("condoName",s.condoName);
        fd.append("severity", s.severity);
        fd.append("description", s.description);
        if (s.reportImage) {
            for (let i = 0; i < s.reportImage.length; i++) {
                fd.append("images", s.reportImage[i]);
            }
        }
        if (s.clientEmail) {
            for (let i = 0; i < s.clientEmail.length; i++) {
                fd.append("clientEmail[]", s.clientEmail[i]);
            }
        }
        if (s.contractorIds) {
            for (let i = 0; i < s.contractorIds.length; i++) {
                fd.append("contractorIds[]", s.contractorIds[i]);
            }
        }
        reportAction.processing(true);
        reportAction.createReport(fd);
    }

    renderCondo() {
        return this.state.condos.map((condo, index) => {
            return (
                <option value={condo.mcst} key={index}>{condo.condoName + " (" + condo.mcst + ")"}</option>
            );
        });
    }
    renderFacility() {
        if (this.state.facility) {
            return this.state.facility.map((facility, index) => {
                return (
                    <option value={facility.facility} key={index}>{facility.facility}</option>
                );
            });
        }
    }
    renderCategory() {
        let s = this.state.report;
        if (this.state.facility) {
            return this.state.facility.map((facility) => {
                if (facility.facility == s.facility) {
                    return facility.categories.map((category, index2) => {
                        return (<option value={category.category} key={index2}>{category.category}</option>);
                    });
                }
            });
        }

    }
    renderImage() {
        let s = this.state.report;
        if (s.reportImage) {
            return s.reportImage.map((image, index) => {
                //convert from blob to img
                let imageformat = URL.createObjectURL(image);
                return (
                    <div className="rp-img-prev" key={index}>
                        <img className="rp-img" src={imageformat} />
                    </div>
                )
            });
        }

    }
    handleEmailChange(e) {
        let value = e.target.value;
        this.setState({ email: value });
    }
    handleEmailRemove(e) {
        e.preventDefault();
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        let s = this.state.report;
        s.clientEmail.splice(index, 1);
        this.setState({ report: s });
    }
    handleEmailClick(e) {
        if (this.state.email != "") {
            let s = this.state.report;
            s.clientEmail = s.clientEmail.concat(this.state.email);
            this.setState({ report: s, email: "" });
        }
    }
    renderEmail() {
        return (
            <div className="form-group">
                <label>Recipients to receive notification</label>
                <form autoComplete="on" style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <div className="input-group" style={{ marginBottom: "10px" }}>
                        <input type="text" className="form-control" placeholder="Email" value={this.state.email}
                            onChange={this.handleEmailChange} autoComplete="on" />
                        <span className="input-group-btn">
                            <button className="btn btn-default" type="button" onClick={this.handleEmailClick}>Add</button>
                        </span>
                    </div>

                    {this.renderEmailList()}
                </form>
            </div>
        );
    }
    renderEmailList() {
        return this.state.report.clientEmail.map((email, index) => {
            return (
                <div className="rp-em" key={index}>
                    <div className="rp-em-1">{email}</div>
                    <button className="rp-em-2 btn btn-xs btn-danger" data-index={index} onClick={this.handleEmailRemove}>Remove</button>
                </div>
            );
        });
    }
    checkContractor(contractor) {
        let isCheck = false;
        let s = this.state.report;
        let len = s.contractorIds.length;
        for (let i = 0; i < len; i++) {
            if (s.contractorIds[i] == contractor._id) {
                isCheck = true;
                break;
            }
        }
        return isCheck;
    }
    renderContractor() {
        if (this.state.contractors) {
            return this.state.contractors.map((contractor, index) => {
                //check if this facility is included;
                let isCheck = this.checkContractor(contractor);

                return (
                    <li className="pm-li-1" key={index}>
                        <div className="checkbox">
                            <label>
                                <input type="checkbox" value={contractor._id}
                                    onChange={this.handleCtrCheck} checked={isCheck} />
                                <span className="checkmark"></span>
                                {contractor.contractorName + " (" + contractor.service + ")"}
                            </label>
                        </div>
                    </li>
                )
            });
        }
    }
    render() {
        let s = this.state.report;
        let category;
        if (s.facility.toUpperCase() == "OTHERS") {
            category = (
                <input className="form-control" name="facility" value={s.category} data-index="2" type="text" onChange={this.handleEdit} />
            )
        } else {
            category = (
                <select className="form-control atd-sel" name="facility" data-index="2" onChange={this.handleChange}
                    value={s.category ? s.category : ""} disabled={this.state.category == "" || s.facility == ""}>
                    <option value=""></option>
                    {this.renderCategory()}
                </select>
            );
        }
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <Loading processing={this.state.processing || this.state.processingFilter} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <div className="contractorSet-form">
                            <div className="row">
                                <div className="col-md-4">
                                    <h4><b>Create Incident Report</b></h4>
                                    <div className="warning">{this.state.warningMsg}</div>
                                    <div className="form-group">
                                        <label htmlFor="estate">Estate</label>
                                        <select className="form-control atd-sel" name="estate" data-index="0" onChange={this.handleChange}
                                            value={s.mcst ? s.mcst : ""}>
                                            <option value=""></option>
                                            {this.renderCondo()}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="facility">Facility</label>
                                        <select className="form-control atd-sel" name="facility" data-index="1" onChange={this.handleChange}
                                            value={s.facility ? s.facility : ""} disabled={this.state.facility == ""}>
                                            <option value=""></option>
                                            {this.renderFacility()}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="category">Category</label>
                                        {category}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="severity">Severity</label>
                                        <select className="form-control atd-sel" name="facility" data-index="3" onChange={this.handleChange}
                                            value={s.severity ? s.severity : ""}>
                                            <option value="0">Low</option>
                                            <option value="1">Medium</option>
                                            <option value="2">High</option>
                                            <option value="3">Critical</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="description">Description</label>
                                        <textarea className="form-control atd-sel" style={{ resize: "none" }} name="description" data-index="4"
                                            onChange={this.handleEdit} rows="3" value={s.description ? s.description : ""} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="description">Images</label>
                                        <input className="form-control" type="file" name="myImage" accept="image/x-png,image/jpeg"
                                            onChange={this.upLoadImg} multiple />
                                    </div>
                                    <div className="rpt-img-prev">
                                        {this.renderImage()}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Contrator">Contractors to receive notification for quotation</label>
                                        {this.renderContractor()}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    {this.renderEmail()}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <button className="btn btn-default" onClick={this.handleSubmit}>Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
export default ReportCreate;


// WEBPACK FOOTER //
// ./app/components/reportCreate.js